export default function SimpleWorkflowState ({
    children, stateMachine
}) {
    const renderedState = children(stateMachine);
    return renderedState;
}